import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SpecialPromotionsState } from "@store/Store/Data/SpecialPromotions/SpecialPromotionsState";
import { SpecialPromotionModel } from "@store/Types/SpecialPromotionModel";
import { Draft } from "immer";

const initialState: SpecialPromotionsState = {
    specialPromotions: [],
};

const reducer = {
    "Store/Data/SpecialPromotions/CompleteLoadSpecialPromotions": (
        draft: Draft<SpecialPromotionsState>,
        action: { specialPromotions: SpecialPromotionModel[]; },
    ) => {
        draft.specialPromotions = action.specialPromotions;
    },
    "Store/Data/SpecialPromotions/ClearSpecialPromotions": (
        draft: Draft<SpecialPromotionsState>,
    ) => {
        draft.specialPromotions = [];
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
